import React from 'react';
import MileageSignupEligibilityBottomSheetKr from '@di-shared/features/home/kr/benefit/MileageSignupEligibilityBottomSheet.kr';

function MileageSignupEligibilityBottomSheetPage() {
  return <MileageSignupEligibilityBottomSheetKr />;
}

export default MileageSignupEligibilityBottomSheetPage;
